import PropTypes from 'prop-types'
import React from 'react'

import { PROGRAM_PRICINGS, PROGRAM_DURATIONS } from '../constants'

function priceOptionsForSelect () {
  let prices = Object.keys(PROGRAM_PRICINGS)

  return prices.map((price, index) => {
    return (
      <option key={index} value={price}>
        {PROGRAM_PRICINGS[price]}
      </option>
    )
  })
}

function startYearOptionsForSelect (selectedYear, rangeStart) {
  if (!rangeStart) {
    rangeStart = (new Date()).getFullYear()
  }
  const years = [rangeStart, rangeStart + 1, rangeStart + 2]

  return years.map((year, index) => {
    return (
      <option key={index} value={year}>
        {year}
      </option>
    )
  })
}

function durationOptionsForSelect () {
  let durations = Object.keys(PROGRAM_DURATIONS)

  return durations.map((duration, index) => {
    return (
      <option key={index} value={duration}>
        {PROGRAM_DURATIONS[duration]}
      </option>
    )
  })
}

function countryOptionsForSelect (availableCountries, prioCCs) {
  let prioCountries = []
  let countryOptions = availableCountries.map((country, index) => {
    let option = (
      <option key={index} value={country.country_code}>
        {country.name}
      </option>
    )
    if (prioCCs.includes(country.country_code)) {
      prioCountries.push(country)
    }
    return option
  })

  prioCountries = prioCountries
    .sort((left, right) => {
      return prioCCs.indexOf(left.country_code) - prioCCs.indexOf(right.country_code)
    })
    .map((country, index) => {
      return (
        <option key={'priority-' + index} value={country.country_code}>
          {country.name}
        </option>
      )
    })

  countryOptions.unshift(
    <option key={'blank'}>----</option>
  )

  countryOptions = prioCountries.concat(countryOptions)

  return countryOptions
}

class ProgramFilter extends React.Component {
  handleChange = (e) => {
    let ele = e.target
    // FIXME: this might not work on checkbox
    this.props.onChange(ele.name, ele.value)
  }

  render() {
    return (
      <React.Fragment>
        <div data-testid='program-filter'>
          <strong className='d-inline-block mb-2'>Filter</strong>
          <div className="form-group mb-1">
            <label htmlFor='countryCode' className='small d-block'>Austauschland</label>
            <select className='form-select form-select-sm'
                    name='countryCode'
                    id='countryCode'
                    value={this.props.countryCode}
                    onChange={this.handleChange}>
              {countryOptionsForSelect(
                this.props.availableCountries,
                this.props.priorityCountryCodes
              )}
            </select>
          </div>
          <div className="form-group mb-1">
            <label htmlFor='duration' className='small'>Dauer</label>
            <select className='form-select form-select-sm'
                    name='duration'
                    id='duration'
                    value={this.props.duration}
                    onChange={this.handleChange}>
              <option value=''>Wähle die Dauer aus</option>
              {durationOptionsForSelect(this.props.duration)}
            </select>
          </div>
          <div className="form-group mb-1">
            <label htmlFor='startYear' className='small'>Startzeitpunkt</label>
            <select className='form-select form-select-sm'
                    name='startYear'
                    id='startYear'
                    defaultValue={this.props.startYear}
                    onChange={this.handleChange}>
              <option value=''>Wähle das Jahr aus</option>
              {startYearOptionsForSelect(this.props.startYear, this.props.startYearRangeStart)}
            </select>
          </div>
          <div className="form-group mb-3">
            <label htmlFor='price' className='small'>Preis</label>
            <select className='form-select form-select-sm'
                    name='price'
                    id='price'
                    defaultValue={this.props.price}
                    onChange={this.handleChange}>
              <option value=''>Wähle das Preislimit aus</option>
              {priceOptionsForSelect(this.props.price)}
              <option value=''>unbegrenzt</option>
            </select>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

ProgramFilter.propTypes = {
  countryCode: PropTypes.string.isRequired,
  availableCountries: PropTypes.array.isRequired,
  priorityCountryCodes: PropTypes.array,
  duration: PropTypes.oneOf(['','0','8','12','16','24','36','48']),
  price: PropTypes.string,
  startYear: PropTypes.string,
  // From which year does the dropdown start (default is the current year)
  startYearRangeStart: PropTypes.number,
  onChange: PropTypes.func.isRequired,
}

export default ProgramFilter
